export function getUrlParams() {
  return getParamsByStr(window.location.href)
}

const getParamsByStr = (str = '') => {
  const paramsArr = str.match(/[^?#&]+=[^?#&]+/g)
  const paramsObj = {} as any
  if (paramsArr) {
    paramsArr.forEach((item) => {
      const arr = item.split('=')
      paramsObj[arr[0]] = window.decodeURIComponent(arr[1])
    })
  }
  return paramsObj
}